/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect, useContext, useRef, useCallback} from "react";
import { purchaseService } from "../../services/purchase.service";
import { Dropdown } from "react-bootstrap";
import LogicContext from "../../Context/LogicContext";
import {GetExpenseListData, SetExpenseListData} from '../../store/expensesAtom';
// import CurrencyFormat from 'react-currency-format';
import Tooltip from "@mui/material/Tooltip";
import RestartAlt from "@mui/icons-material/RestartAlt";
import { useState } from "react";
import GeneralModal from "../../helpers/GeneralModal";
import { createModal } from "react-modal-promise";
import { useLocation, useNavigate } from "react-router-dom";
import ActionPaneComponent from "../../helpers/ActionPaneComponent";
import GeneralCustomTable from "../../helpers/GeneralCustomTable";
import { accountService } from "../../services/accountService";
import { formatCustomNumber } from "../../helpers/formatCustomNumber";
import DelgroProgressBar from "../../generals/DelgroProgressBar";
import { useForm } from "react-hook-form";
import moment from "moment";
import ExpensePageFilter from "./ExpensePageFilter";
import StatusBadge from "../../generals/StatusBadge";



const columns = [
  {
    title: 'Ref.No',
    key: 'Ref_No',
    dataIndex: 'Ref_No',
    sorter: (a, b) => (a?.Ref_No ?? '') - (b?.Ref_No ?? '')

    //   render: () => <HolderOutlined style={{ fontSize: '20px', color:'blue' }} />,
  },
  {
    title: 'Expense Date',
    dataIndex: 'Expense_Date_String',
    className: "text-Expense_Date_String",
    sorter: (a, b) => (a?.Expense_Date_String ?? '').localeCompare(b?.Expense_Date_String ?? '')

    //   render: () => <HolderOutlined style={{ fontSize: '20px', color:'blue' }} />,
  },
  {
    title: 'Expense Account',
    key: 'Expense_Account_Name',
    dataIndex: 'Expense_Account_Name',
    // className: "text-Expense_Account_Name",
    sorter: (a, b) => (a?.Expense_Account_Name ?? '').localeCompare(b?.Expense_Account_Name ?? '')
    //   render: () => <HolderOutlined style={{ fontSize: '20px', color:'blue' }} />,
  },

  {
    title: 'Paid Account',
    key: 'Paid_Account_Name',
    dataIndex: 'Paid_Account_Name',
    // className: "text-Paid_Account_Name",
    sorter: (a, b) => (a?.Paid_Account_Name ?? '').localeCompare(b?.Paid_Account_Name ?? '')
    //   render: () => <HolderOutlined style={{ fontSize: '20px', color:'blue' }} />,
  },

  {
    title: 'Vendor',
    dataIndex: 'Vendor_Name',
    sorter: (a, b) => (a?.Vendor_Name ?? '').localeCompare(b?.Vendor_Name ?? '')

    //   render: () => <HolderOutlined style={{ fontSize: '20px', color:'blue' }} />,
  },


  {
    title: 'Amount',
    key: 'Amount',
    dataIndex: 'Amount',
    sorter: (a, b) => (a?.Amount ?? '') - (b?.Amount ?? ''),
      render: (record) => <span> {formatCustomNumber(record)} </span> ,
  },
 
  {
    title: 'Status',
    dataIndex: 'Status_Name',
    sorter: (a, b) => (a?.Status_Name ?? '').localeCompare(b?.Status_Name ?? ''),
    render: (record, row) => (
      <StatusBadge statusId={row?.Status_Id} statusName={record} />
    ),
  },



];


function ExpenseMainPage() {
  const { pathname } = useLocation();  
  const navigate = useNavigate();
  var url = pathname.split('/')
  const currModuleId = url[1];
  const currModuleName = url[2];
  const currUserMenu = url[3];
  const setExpenseListData =  SetExpenseListData();
  const getExpenseListData =  GetExpenseListData();
  const myPromiseModal = createModal(GeneralModal);
    const logicContext = useContext(LogicContext);

  
  const [tableData, setTableData] = useState([]);
  const [itemSelected, setItemSelected] = useState([]);
  const mountRef = useRef(false);

     const {   register,  setValue,  getValues,   handleSubmit,
        reset, formState: { errors }  } = useForm();
  


  useEffect(()=> {
    document.title = 'Expenses';
    if(!getExpenseListData?.expense_info?.length){
      getExpensesListFromApi();
    }else{
      setTableData(getExpenseListData.expense_info);
    }
   
  },[  ]);


    useEffect(() => {
      if (sessionStorage.getItem("reloadPage") === "true") {
        sessionStorage.removeItem("reloadPage");
        getExpensesListFromApi();
      }
    }, []);


const  getExpensesListFromApi =  async() => {
  accountService.getExpenseMainList().then( response => {
    const serverData =  response?.data;
    if(serverData?.expense_info?.length){
        setTableData(serverData?.expense_info);
    }

    const buildData = {
        vendor_info:serverData?.vendor_info?.length ? serverData?.vendor_info: [],
        expense_account:serverData?.expense_account?.length ? serverData?.expense_account: [],
        expense_info:serverData?.expense_info?.length ? serverData?.expense_info: [],
        expense_status:serverData?.expense_status?.length ? serverData?.expense_status: [],
        paid_account:serverData?.paid_account?.length ? serverData?.paid_account: [],
        tax_info:serverData?.tax_info?.length ? serverData?.tax_info: [],


    }
    
    setExpenseListData(buildData);
 
    });
  }



  const onActionFilterPerform = event => {
     const selectedIndex = event.target.value;
    const selection = getExpenseListData['expense_status'][selectedIndex];

    // if (Number(option) === 0) {
    //   return setTableData(getExpenseListData['Purchase_Order_Info']);
    // }
    var newList = getExpenseListData['expense_info'].filter(item => item.Purchase_Order_Status_Id == selection?.Expense_Status_Id);
    setTableData(newList);
  };

  

  function selectedTableItems(itemList) {
    setItemSelected(itemList);
  }



  function addNewInvoice(){
    navigate(`/${currModuleId}/${currModuleName}/${currUserMenu}/add-new`)
  }




  async function bulkActions(action) {
    await myPromiseModal({ title: 'confirm your action!',
      body: `Do you want to ${action.Action_Name} ?`,showInput:false, placeHolder:''
    }).then((result) => {
     
      if(result.decision === true){
        let temp = '';
        const option = action.Procedure_Option;
        itemSelected.map(item => {
          temp += `<a> <refno> ${item.Purchase_Order_Ref_No} </refno> </a>`
        });
  
        let xml_string_refno = `<root> ${temp} </root>`;
      //   accountService.setPurchaseBulkAction({xml_string_refno, option}).then(res => {
      //     if(res?.data !== undefined){
      //       const {message_text} = res.data[0];
      //       logicContext.showToast(message_text, 'success');
      //      return  getPurchaseOrderListApi();
      //     }
      // }).catch((err)=> {
      //   logicContext.showToast('Error', 'error');
      // });
      }

    });
  }

  function OnItemCellClick(expense){
    const id = expense['Ref_No'];
    navigate(`/${currModuleId}/${currModuleName}/${currUserMenu}/details/${id}`)
  }



      const searchByDate = async (event) => {
        const formData = getValues();
        const response = await accountService.getExpenseByDate(formData);
        if (response?.data?.length) {
          setTableData(response?.data);
        } else {
          logicContext.showToast("No result found", "");
          setTableData([]);
        }
      };
  


  return (
    <>
      <section>
        <section className="bg-white  px-2    md:flex justify-between ">
          <div className="flex px-2 mt-1">
            {itemSelected?.length > 0 ? (
              <div className="row">
                <div className="col col-md-4">
                  <Dropdown>
                    <Dropdown.Toggle
                      style={{
                        backgroundColor: '#E5E5E5',
                        border: 'none',
                        color: '#45444B',
                        fontSize: '12px',
                        height: '45px',
                      }}
                      id="dropdown-basic"
                    >
                      Bulk Actions
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      {getExpenseListData['expense_status']?.map((action, i) => {
                        return (
                          <Dropdown.Item key={i} onClick={() => bulkActions(action)}>
                            {action.Action_Name}
                          </Dropdown.Item>
                        );
                      })}
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>
            ) : (
              <>
              {/* <ExpensePageFilter bulkActionData={getExpenseListData['expense_status']} onSelectBulkAction={onActionFilterPerform} /> */}
              
              </>
            )}

            <Tooltip title="Reload">
              <RestartAlt className="cursor ml-2 mt-1" onClick={() => getExpensesListFromApi()} color="primary" fontSize="large" />
            </Tooltip>
          </div>

          {/* date search */}
          <div class="flex flex-row items-end space-x-2">
            <div>
              <span className="ml-1 text-sm ">From Date:</span>
              <input
                defaultValue={moment(Date.now()).format('YYYY-MM-DD')}
                {...register('from_date')}
                className=" bg-white ring-1 ring-gray-200  w-full pl-3  rounded max-h-full bottom-0 outline-none border-transparent focus:border-transparent focus:ring-0"
                type="date"
              />
            </div>

            <div>
              <span className="ml-1 text-sm ">To Date:</span>
              <input
                {...register('to_date')}
                defaultValue={moment(Date.now()).format('YYYY-MM-DD')}
                className=" bg-white ring-1 ring-gray-200  w-full pl-3  rounded max-h-full bottom-0 outline-none border-transparent focus:border-transparent focus:ring-0"
                type="date"
              />
            </div>
            <div>
              <button onClick={() => searchByDate()} type="button" className="text-sm text-white px-3 bg-blue-500 rounded py-2.5">
                Search
              </button>
            </div>
          </div>
          {/* date search end */}

          <div className="flex justify-between">
            <button className="  font-[Poppins] font-bold py-2 mt-1 px-2 rounded md:ml-8 text-sm">IMPORT</button>
            <div className="btn-group">
              <button
                className=" font-[Poppins] font-bold py-2 mt-1 px-2 rounded md:ml-8   text-sm"
                data-toggle="dropdown"
                aria-expanded="false"
              >
                EXPORT
              </button>
            </div>

            <button
              onClick={addNewInvoice}
              className="bg-buttonColor font-[Poppins] py-3 mt-1 mr-1 px-3 rounded md:ml-8  text-white text-xs"
            >
              ADD NEW
            </button>
          </div>
        </section>

        <section className="mt-5">
          {!tableData?.length && !getExpenseListData?.expense_account?.length && <DelgroProgressBar />}

          <GeneralCustomTable
            tableHeadList={columns}
            tableDataList={tableData}
            allowCheckBox={true} // show checkBox for each row
            setSelectedRows={selectedTableItems}
            rowKey={record => record.Ref_No} // custom key
            handleRowClick={OnItemCellClick}
          />
        </section>
      </section>
    </>
  );
}

export default ExpenseMainPage;
